var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44 44",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#5e646b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,12 L28,5.99124431 C28,4.89989752 27.10296,4 25.9964051,4 L5.00359486,4 C3.88976324,4 3,4.89151044 3,5.99124431 L3,30.0087557 C3,31.1001025 3.89703997,32 5.00359486,32 L25.9964051,32 C27.1102368,32 28,31.1084896 28,30.0087557 L28,24 L24,24 L24,28 L7,28 L7,8 L24,8 L24,12 L28,12 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,15 L11,15 L11,21 L31,21 L31,27 L41,18 L31,9 L31,15 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRight);
export default __webpack_public_path__ + "static/media/copyRight.0f40375bff1870a520dcc17ef5fa777b.svg";
export { ForwardRef as ReactComponent };